export const affordableEsTranslation = {
  affordable: {
    prequalify: {
      title: "Pre-Calificación de Ingresos",
      subtitle: "Verifique si puede calificar para vivienda asequible en",
      incomeRestricted:
        "Este Complejo de Apartamentos tiene apartamentos con restricción de ingresos.",
      incomeRestrictedDescription:
        "Una unidad que requiere que su hogar cumpla con ciertas restricciones, como ingresos y estado de estudiante, que se basan en Programas de Vivienda Federales, Estatales o Locales.",
      householdSize: "El Tamaño de Su Hogar",
      householdSizeLabel:
        "¿Cuántas personas en total residirán en su hogar durante los próximos 12 meses (incluyendo menores y cualquier miembro nuevo previsto, como un recién nacido, cónyuge o familiar que se mude con usted)?",
      continueToIncome: "Continuar",
      change: "Cambiar",
      annualIncome: "Ingreso Bruto Anual",
      incomeInputLabel:
        "¿Cuál es el ingreso bruto estimado de su hogar para los próximos 12 meses?",
      incomeInputHelperGross:
        "Use el ingreso bruto (antes de impuestos y deducciones) — no el ingreso neto ni la paga neta. Los límites de elegibilidad se basan en el ingreso bruto, así que reportar la paga neta puede llevar a un resultado incorrecto.",
      incomeInputHelperInclude:
        "Incluya el ingreso bruto de todos los miembros adultos del hogar — sueldos, salarios, trabajo por cuenta propia, seguro social, pensiones y otros ingresos regulares.",
      incomeInputHelperFallback:
        "Si no puede estimar los próximos 12 meses, use el ingreso bruto del hogar del año anterior como punto de partida.",
      checkEligibility: "Verificar Mi Elegibilidad",
      loadingUnitRent: "Confirmando el requisito de alquiler de esta unidad...",
      eligible: {
        title: "¡Puede Calificar!",
        message:
          "Según la información proporcionada, el ingreso de su hogar está dentro de los límites de ingresos para esta propiedad.",
        continueButton: "Continuar con la Solicitud",
      },
      underMinimum: {
        title: "Ingreso por Debajo del Requisito Mínimo",
        message:
          "Según el ingreso que ingresó, su hogar parece estar por debajo del requisito mínimo de ingresos para esta unidad.",
      },
      overIncome: {
        title: "Parece que Excede el Límite de Ingresos",
        message:
          "Según el ingreso que ingresó, su hogar parece exceder los límites de ingresos para una unidad con restricción de ingresos en esta propiedad.",
        contactPrompt:
          "Comuníquese con nuestra oficina antes de continuar para que podamos revisar su situación y discutir sus opciones.",
      },
      error: {
        propertyNotFound: "Propiedad no encontrada",
        notAffordable:
          "Esta propiedad no participa en programas de vivienda asequible.",
        noIncomeLimits:
          "Los límites de ingresos aún no están disponibles para esta propiedad. Comuníquese con la oficina de la propiedad.",
        unitRentUnavailable:
          "No pudimos confirmar el requisito de alquiler de esta unidad. Inténtelo de nuevo o comuníquese con la oficina de la propiedad.",
      },
    },
    application: {
      title: "Solicitud de Vivienda Asequible",
      notFound: "Solicitud no encontrada",
      unsavedStepNavigation:
        "Este paso aún no está guardado. Haga clic en Siguiente para guardarlo antes de salir. ¿Salir sin guardar?",
      correctionBanner:
        "Esta solicitud se reabrió para correcciones. Actualice los datos a continuación y luego revísela y vuelva a enviarla para enviar sus cambios.",
      steps: {
        authorizationToAssist: "Autorización",
        memberProfiles: "Perfiles de Miembros",
        rentalDetails: "Detalles del Alquiler",
        studentStatus: "Estado Estudiantil",
        specialNeeds: "Necesidades Especiales",
        specialStatus: "Estado Especial",
        householdIncome: "Ingresos del Hogar",
        assets: "Activos",
        financialSummary: "Resumen Financiero",
        uploadCenter: "Centro de Cargas",
        reviewSign: "Revisar y Firmar",
      },
      continue: "Continuar",
      authorizationToAssist: {
        title: "¿Necesita ayuda con esta solicitud?",
        description:
          "Las solicitudes de vivienda asequible incluyen varias certificaciones. Si alguien le está ayudando a completar esta solicitud, debe autorizarlo por escrito antes de comenzar.",
        yes: "Sí, alguien me está ayudando",
        no: "No, la estoy completando por mi cuenta",
        assisterDetails: "Cuéntenos sobre la persona que le ayuda",
        assisterNameLabel: "Nombre de la persona que le ayuda",
        assisterEmailLabel: "Su correo electrónico",
        assisterEmailHint:
          "Le enviaremos un enlace para firmar su parte de la autorización.",
        relationshipLabel: "Su relación con usted",
        relationshipOtherLabel: "Describa",
        relationship: {
          propertyStaff:
            "Personal de la propiedad (ej. agente de arrendamiento)",
          caseworker: "Mi trabajador social",
          familyMember: "Un familiar",
          other: "Otro",
        },
        reasonLabel: "¿Por qué necesita ayuda?",
        reasonOtherLabel: "Describa",
        reason: {
          difficultyWriting: "Dificultad para escribir",
          difficultyUnderstanding: "Dificultad para entender los formularios",
          lep: "Conocimiento limitado del inglés",
          other: "Otro",
        },
        afterSendNote:
          "Al continuar, crearemos la autorización, usted la firmará en la siguiente pantalla y su ayudante recibirá un correo electrónico con un enlace para firmar su parte.",
        sendAndSign: "Continuar para firmar",
        signNow: "Firme la autorización",
        signWidgetHint:
          "Firme su parte arriba. Su ayudante recibirá un correo con un enlace para firmar su parte — puede continuar con la solicitud ahora.",
        iSigned: "He firmado — Continuar",
        lockedSigned:
          "Ya firmó una Autorización para Asistir para esta solicitud.",
        lockedDeclined: "Rechazó asistencia para esta solicitud.",
        errorGeneric:
          "Algo salió mal. Por favor intente de nuevo o contacte la oficina de la propiedad.",
      },
      coApplicant: {
        steps: {
          identity: "Confirmar identidad",
        },
        identity: {
          title: "Confirma tu identidad",
          subtitle:
            "Tenemos tu nombre en el archivo del hogar al que fuiste invitado. Por favor confírmalo y agrega tu fecha de nacimiento y SSN.",
        },
        header: {
          unit: "Unidad",
          moveIn: "Mudanza",
        },
      },
      liveInAide: {
        placeholder: "Este paso estará disponible próximamente.",
        steps: {
          identity: "Confirmar identidad",
          rentalHistory: "Historial de alquiler",
          household: "Hogar",
          careAttestations: "Atestaciones de cuidado",
          medicalExpense: "Gasto médico",
          criminalScreening: "Verificación de antecedentes",
          statesLived: "Estados donde ha vivido",
          leasingAck: "Reconocimientos de arrendamiento",
          review: "Revisar y enviar",
        },
        identity: {
          title: "Confirma tu identidad",
          subtitle:
            "Tenemos tu nombre y correo electrónico en el archivo del hogar que te invitó. Por favor confirma tus datos para que podamos completar previamente tus formularios de asistente residente.",
          contactLabel: "Contacto",
          homePhoneLabel: "Teléfono de casa",
          mobilePhoneLabel: "Teléfono móvil",
          residentServedLabel:
            "Nombre del residente que recibirá los servicios",
          residentServedRequired: "El nombre del residente es obligatorio",
          exemptLabel: "Estado de exención",
          exemptCaption:
            "Marque una casilla solo si está exento de proporcionar un número de Seguro Social. La mayoría de los asistentes no lo están; si no está seguro, deje ambas sin marcar.",
          exemptNonCitizen: "No ciudadano no elegible",
          exemptNonCitizenHelp:
            "No está reclamando un estatus migratorio elegible.",
          exemptSenior: "Adulto mayor con estado de exención",
          exemptSeniorHelp:
            "Es un miembro del hogar de edad avanzada cubierto por la exención del número de Seguro Social de HUD.",
        },
        rentalHistory: {
          title: "Historial de alquiler",
          subtitle:
            "Indíquenos dónde vive ahora y dónde vivía antes. El personal de la propiedad lo usa para verificar referencias del arrendador.",
          currentTitle: "Residencia actual",
          previousTitle: "Residencia anterior",
          previousNote:
            "Opcional, pero si comienza a completarla, necesitaremos la dirección.",
          landlordLabel: "Nombre de la comunidad / arrendador",
          addressLabel: "Dirección",
          cityLabel: "Ciudad",
          stateLabel: "Estado",
          zipLabel: "Código postal",
          phoneLabel: "Teléfono",
          startDateLabel: "Fecha de inicio",
          endDateLabel: "Fecha de finalización",
          landlordRequired:
            "El nombre de la comunidad / arrendador es obligatorio",
          addressRequired: "La dirección es obligatoria",
          cityRequired: "La ciudad es obligatoria",
          stateRequired: "El estado es obligatorio",
          zipRequired: "El código postal es obligatorio",
          zipError: "Ingrese un código postal válido",
        },
        household: {
          title: "Hogar",
          subtitle:
            "Unas preguntas rápidas sobre su situación de vivienda. Por favor responda cada una.",
          required: "Por favor responda esta pregunta",
          yes: "Sí",
          no: "No",
          evictedExplainLabel: "Si respondió sí, por favor explique",
          evictedExplainRequired: "Se requiere una explicación",
          questions: {
            hudAssistance:
              "¿Recibe actualmente asistencia de vivienda a través de HUD?",
            otherFamilyMoving:
              "¿Hay otros miembros de la familia que planean mudarse a la unidad con usted (excluyendo al residente)?",
            pets: "¿Tiene mascotas?",
            goodStanding:
              "¿Es actualmente un residente en buen estado en su residencia actual?",
            evicted:
              "¿Ha sido desalojado, por violaciones del contrato de arrendamiento, por un arrendador durante los últimos 5 años?",
          },
        },
        careAttestations: {
          title: "Requisitos del asistente residente",
          subtitle:
            "HUD define a un asistente residente según estos requisitos. Por favor responda cada uno.",
          required: "Por favor responda esta pregunta",
          yes: "Sí",
          no: "No",
          questions: {
            essentialCare: "¿Puede proporcionar cuidado esencial al residente?",
            obligatedSupport: "¿Está obligado a brindar apoyo al residente?",
            wouldNotLiveExcept:
              "¿Está de acuerdo en que no viviría en la unidad excepto para brindar los servicios de apoyo necesarios al residente?",
          },
        },
        medicalExpense: {
          title: "Gasto médico",
          subtitle:
            "Esto ayuda a determinar cualquier deducción por gastos médicos para el hogar del residente.",
          feeQuestion:
            "¿El residente mencionado anteriormente le pagará una tarifa por proporcionar los servicios de un asistente residente?",
          required: "Por favor responda esta pregunta",
          yes: "Sí",
          no: "No",
          amountLabel: "Monto de la tarifa",
          amountRequired: "El monto es obligatorio",
          frequencyLabel: "Frecuencia",
          frequencyRequired: "La frecuencia es obligatoria",
          frequencies: {
            yearly: "Anual",
            monthly: "Mensual",
            weekly: "Semanal",
          },
        },
        criminalScreening: {
          title: "Verificación de antecedentes penales",
          subtitle:
            "El personal de la propiedad usa estas respuestas para completar la verificación de antecedentes requerida. Por favor responda cada una.",
          required: "Por favor responda esta pregunta",
          yes: "Sí",
          no: "No",
          explainLabel: "Si respondió sí, por favor explique",
          explainRequired: "Se requiere una explicación",
          questions: {
            legalActions10y:
              "¿Ha estado involucrado en alguna acción legal, incluyendo arrestos, adjudicaciones, acciones penales o civiles, durante los últimos 10 años?",
            sexOffenderLifetime:
              "¿Está incluido en el registro vitalicio de delincuentes sexuales de algún estado?",
            sexOffenderOther:
              "¿Está incluido en cualquier otro registro de delincuentes sexuales?",
            marijuana: "¿Usa marihuana?",
            alcoholAbuse: "¿Tiene antecedentes de abuso de alcohol?",
          },
        },
        statesLived: {
          title: "Estados donde ha vivido",
          subtitle:
            "Por favor seleccione cada estado donde ha vivido, incluyendo Washington, D.C.",
          label: "Estados donde ha vivido",
          placeholder: "Escriba para buscar estados…",
        },
        leasingAck: {
          title: "Reconocimientos de arrendamiento",
          subtitle:
            "Por favor confirme que entiende y acepta lo siguiente. Responda cada pregunta.",
          required: "Por favor responda esta pregunta",
          yes: "Sí",
          no: "No",
          questions: {
            readLease:
              "¿Ha leído y entiende el Contrato de Arrendamiento, las reglas y los reglamentos?",
            agreeAbide:
              "¿Acepta cumplir con todos los términos del Contrato y las reglas y reglamentos del Arrendador?",
            understandEviction:
              "¿Entiende que el arrendador tomará las medidas apropiadas, incluyendo el desalojo, si no cumple?",
            noOccupancyRights:
              "¿Entiende que ocupa esta unidad únicamente para brindar cuidado al residente y no tiene derecho a continuar la ocupación si el residente se muda?",
            vacateIfAbsent:
              "¿Acepta desocupar la unidad si el residente está ausente por más de 120 días (180 por motivos médicos)?",
            vacateOnDeath:
              "En caso de que el residente fallezca, ¿entiende que debe desocupar lo antes posible (el subsidio de HUD termina 14 días después del fallecimiento)?",
          },
        },
        review: {
          title: "Revisar y enviar",
          subtitle:
            "Por favor revise sus respuestas a continuación antes de enviar. Firmará sus formularios de Asistente Residente más tarde, después de la revisión del personal.",
          submit: "Enviar",
          yes: "Sí",
          no: "No",
          notAnswered: "Sin responder",
          noSsn: "Sin SSN en archivo",
          noneSelected: "Ninguno seleccionado",
          signLater:
            "No firmará nada en esta pantalla. Después de que el personal revise su envío, se le invitará a firmar sus formularios de Asistente Residente ya prellenados.",
          sections: {
            identity: "Identidad",
            rentalHistory: "Historial de vivienda",
            household: "Hogar",
            careAttestations: "Declaraciones de cuidado",
            medicalExpense: "Gasto médico",
            criminalScreening: "Verificación de antecedentes",
            statesLived: "Estados donde ha vivido",
            leasingAck: "Reconocimientos de arrendamiento",
          },
          labels: {
            dob: "Fecha de nacimiento",
            ssn: "SSN o ITIN",
            residentServed: "Residente que recibe los servicios",
            currentResidence: "Residencia actual",
            previousResidence: "Residencia anterior",
          },
        },
      },
      memberProfiles: {
        livingNowOrAnticipated:
          "¿Vive con usted ahora o se anticipa dentro de 12 meses?",
        livingNow: "Vive conmigo actualmente",
        anticipated: "Anticipado dentro de 12 meses",
        anticipatedHelper:
          "Use esto para recién nacidos, adopciones planeadas, futuros cónyuges o compañeros de casa que se mudarán. Los documentos de identidad se recopilarán al momento de la mudanza.",
        anticipatedReasonLabel: "Motivo",
        anticipatedReasons: {
          newborn: "Recién nacido / embarazo",
          adoption: "Adopción o colocación en hogar de acogida",
          marriage: "Matrimonio o nuevo cohabitante",
          roommate: "Nuevo compañero de casa",
          other: "Otro",
        },
        anticipatedReasonRequired: "El motivo es requerido",
        anticipatedArrivalLabel: "Llegada esperada",
        anticipatedArrivalHelper: "MM/AAAA",
        anticipatedArrivalRequired: "La llegada esperada es requerida",
        anticipatedArrivalError: "Use el formato MM/AAAA",
        yes: "Sí",
        no: "No",
        custodySectionLabel: "Custodia",
        custodySectionHelper:
          "Los programas HUD/PBRA/811 requieren verificación de la custodia física de cada menor en el hogar.",
        hasMajorityCustodyLabel:
          "¿Este menor reside con usted al menos el 50% del tiempo?",
        hasMajorityCustodyRequired: "Indique el arreglo de custodia",
        isFosterPlacementLabel:
          "¿Es este menor una colocación de crianza temporal (foster)?",
        isFosterPlacementRequired:
          "Indique si este menor es una colocación de crianza temporal",
        custodyPercentLabel: "¿Cuál es el arreglo de custodia compartida?",
        custodyPercentPlaceholder: "p. ej. 50%, semanas alternas, principal",
        custodyPercentHelper:
          "Describa el arreglo en forma de porcentaje u horario. El personal de la propiedad lo reconciliará con la orden judicial si se sube.",
        custodyPercentRequired: "El arreglo de custodia es requerido",
        hasCourtOrderLabel: "¿Hay una orden judicial vigente?",
        hasCourtOrderRequired: "Indique si existe una orden judicial",
        hasCourtOrderHelper:
          "Si es Sí, se le pedirá subir la orden actual en el Centro de Carga.",
        willAnyoneLive:
          "¿Vivirá alguien más con usted o se unirá a su hogar en los próximos 12 meses?",
        answerRequired: "Por favor responda esta pregunta",
        memberRequired: "Agregue al menos un miembro del hogar",
        addFirstMember: "Agregar un miembro del hogar",
        emptyState: "Aún no se han agregado miembros adicionales.",
        memberLabel: "Miembro",
        liveInAide: "Asistente Residente",
        phoneError: "Use el formato (XXX) XXX-XXXX",
        dobError: "Use el formato MM/DD/AAAA",
        dobRequired: "La fecha de nacimiento es requerida",
        mustBe18: "Debe ser mayor de 18 años",
        ssnLabel: "SSN o ITIN",
        noSsnThirdPerson: "No tiene SSN",
        ssnRequired: "El SSN o ITIN es requerido",
        ssnDigits: "El SSN o ITIN debe tener 9 dígitos",
        idSectionLabel: "Identificación oficial",
        idSectionHelper:
          "Opcional — los menores normalmente no tienen una identificación oficial. Déjelo en blanco si no la tienen.",
        govIdTypeLabel: "Tipo de identificación",
        govIdTypeRequired: "El tipo de identificación es requerido",
        govIdLabel: "Número de identificación",
        govIdRequired: "El número de identificación es requerido",
        govIdTypes: {
          driversLicense: "Licencia de conducir",
          stateId: "Identificación estatal",
          passport: "Pasaporte / Tarjeta de pasaporte",
          militaryId: "Identificación militar",
          itin: "ITIN",
          foreignGovId: "Identificación oficial de su país de origen",
          other: "Otra identificación oficial",
        },
        studentStatusLabel: "Estado Estudiantil",
        studentStatusRequired: "Por favor seleccione un estado estudiantil",
        studentStatusFullTime: "Tiempo Completo",
        studentStatusPartTime: "Tiempo Parcial",
        studentStatusNotStudent: "No es Estudiante",
        firstNameRequired: "El nombre es requerido",
        lastNameRequired: "El apellido es requerido",
        relationshipRequired: "La relación es requerida",
        emailRequired: "El correo electrónico es requerido",
        emailDuplicate:
          "Cada solicitante necesita su propio correo electrónico — este ya lo usa otro miembro del hogar.",
        emailMatchesPrimary:
          "Este correo electrónico ya lo usa el solicitante principal. Cada solicitante adulto necesita su propio correo electrónico.",
        emailHelper:
          "Esta persona recibirá una invitación para completar su propia solicitud",
        memberPhoneHelper:
          "Se usa como respaldo por SMS si la invitación por correo no llega o no es respondida.",
        householdSizeMismatch:
          "Indicó {{expected}} personas en su hogar durante la pre-calificación, pero solo {{actual}} están registradas (incluyéndose a usted). Agregue a los miembros restantes o actualice el tamaño de su hogar si ha cambiado.",
      },
      demographics: {
        title: "Datos demográficos",
        helper:
          "Reporte para TDHCA / HUD. Puede optar por no responder; no afectará su solicitud.",
        optOut:
          "No deseo proporcionar información sobre etnia, raza, sexo y estado de discapacidad.",
        optOutThirdPerson:
          "Declinar proporcionar etnia, raza, sexo y estado de discapacidad.",
        required:
          "Seleccione una opción (o marque declinar proporcionar arriba)",
        sexLabel: "Sexo",
        sexMale: "Masculino",
        sexFemale: "Femenino",
        ethnicityLabel: "Etnia",
        ethnicityHispanic: "Hispano o Latino",
        ethnicityNotHispanic: "No Hispano ni Latino",
        raceLabel: "Raza",
        raceHelper: "Seleccione todas las que apliquen (hasta 5)",
        raceWhite: "Blanco",
        raceBlack: "Negro / Afroamericano",
        raceAmericanIndian: "Indígena Americano / Nativo de Alaska",
        raceAsianIndian: "Indio Asiático",
        raceChinese: "Chino",
        raceFilipino: "Filipino",
        raceJapanese: "Japonés",
        raceKorean: "Coreano",
        raceVietnamese: "Vietnamita",
        raceOtherAsian: "Otro Asiático",
        raceNativeHawaiian: "Nativo de Hawái",
        raceGuamanian: "Guameño o Chamorro",
        raceSamoan: "Samoano",
        raceOtherPacific: "Otro Isleño del Pacífico",
        raceOther: "Otro",
        disabledLabel: "¿Tiene una discapacidad?",
        yes: "Sí",
        no: "No",
        didNotRespond: "Prefiero no decirlo",
      },
      rentalDetails: {
        yes: "Sí",
        no: "No",
        rentalHistoryTitle: "Historial de Vivienda",
        rentalHistoryNote:
          "Necesitamos al menos {{months}} meses de historial de vivienda. Si ha estado en su dirección actual menos de {{months}} meses, proporcione también su dirección anterior.",
        currentAddressTitle: "Dirección Actual",
        previousAddressTitle: "Dirección Anterior",
        previousAddressNote:
          "Requerido porque ha estado en su dirección actual menos de {{months}} meses. Agregue direcciones hasta cubrir los últimos {{months}} meses.",
        previousAddressHeading: "Dirección Anterior {{number}}",
        addAnotherAddress: "Agregar otra dirección",
        removeAddress: "Eliminar",
        historyCovered:
          "{{covered}} de {{months}} meses de historial de alquiler ingresados.",
        rentalHistoryCoverageError:
          "Agregue direcciones anteriores hasta cubrir al menos {{months}} meses de historial de alquiler.",
        housingSituation: "Situación de Vivienda Actual",
        housingSituationRenting: "Alquilando actualmente",
        housingSituationWithFamily: "Vive con familiares o amigos",
        housingSituationOwnHome: "Soy dueño de mi casa",
        street: "Dirección",
        city: "Ciudad",
        state: "Estado",
        zip: "Código Postal",
        moveInDate: "Fecha de Mudanza",
        moveOutDate: "Fecha de Salida",
        landlord: "Propietario / Administrador",
        landlordPhone: "Teléfono del Propietario",
        landlordEmail: "Correo del Propietario",
        landlordEmailHelper: "Acelera las referencias.",
        landlordEmailError: "Ingrese un correo electrónico válido",
        landlordContactHelper:
          "Proporcione al menos uno — teléfono o correo — para que podamos verificar referencias de alquiler.",
        landlordContactBothHelper:
          "Para su dirección actual, proporcione el teléfono y el correo del propietario para poder verificar referencias de alquiler.",
        landlordContactRequired:
          "Proporcione un teléfono o correo del propietario para verificar referencias de alquiler.",
        landlordPhoneRequired:
          "El teléfono del propietario es requerido para su dirección actual.",
        landlordEmailRequired:
          "El correo del propietario es requerido para su dirección actual.",
        reasonForLeaving: "Motivo de Mudanza",
        streetRequired: "La dirección es requerida",
        cityRequired: "La ciudad es requerida",
        stateRequired: "El estado es requerido",
        zipRequired: "El código postal es requerido",
        zipError: "Use el formato de 5 o 9 dígitos",
        moveInDateRequired: "La fecha de mudanza es requerida",
        moveOutDateRequired: "La fecha de salida es requerida",
        monthYearError: "Use el formato MM/AAAA",
        previousRequired:
          "Proporcione su dirección anterior (requerida cuando la mudanza actual es reciente).",
        householdNeedsTitle: "Necesidades del Hogar",
        utilitiesQuestion:
          "¿Puede establecer y mantener todos los servicios públicos requeridos para esta unidad a su nombre (o al nombre de otro miembro adulto del hogar)?",
        utilitiesRequired: "Seleccione sí o no",
        utilityIssueLabel: "¿Cuál de las siguientes opciones aplica?",
        utilityIssueRequired: "Seleccione una opción",
        utilityIssueOutstandingBalance:
          "Tengo un saldo pendiente con un proveedor de servicios públicos local",
        utilityIssueCreditDeposit:
          "Puedo necesitar un cofirmante o un depósito alto para establecer el servicio",
        utilityIssueFraudIdentity:
          "Hay un bloqueo en mi identidad que impide crear cuentas de servicios públicos",
        utilityIssueFollowupNote:
          "El equipo de la propiedad se comunicará para hablar sobre los siguientes pasos (por ejemplo, comprobante de un plan de pago o un cofirmante).",
        accessibilityQuestion:
          "¿Usted o algún miembro del hogar necesita una unidad adaptada o tiene necesidades de accesibilidad que debamos conocer?",
        accessibilityRequired: "Seleccione sí o no",
        accessibilityDetails: "Por favor describa",
        accessibilityDetailsRequired:
          "Describa sus necesidades de accesibilidad",
        accessibilityDetailsHelper:
          "Se comparte solo con el equipo de arrendamiento para apoyar una solicitud de adaptación razonable.",
        emergencyContactTitle: "Contacto de Emergencia",
        emergencyContactNote:
          "Proporcione un contacto de emergencia. Solo nos comunicaremos por las razones que usted seleccione a continuación.",
        emergencyDecline: "Elijo no proporcionar un contacto de emergencia",
        emergencyName: "Nombre Completo",
        emergencyRelationship: "Relación",
        emergencyPhone: "Teléfono",
        emergencyNameRequired: "El nombre es requerido",
        emergencyRelationshipRequired: "La relación es requerida",
        emergencyPhoneRequired: "El teléfono es requerido",
        emergencyReasonsLabel:
          "¿Cuándo podemos contactar a esta persona? (marque todas las que correspondan)",
        emergencyReasons: {
          emergency: "Emergencia",
          unableToContact: "Imposibilidad de contactarle",
          terminationOfAssistance: "Terminación de asistencia",
          latePayment: "Pago atrasado o incumplimiento del alquiler",
          eviction: "Desalojo",
          leaseTermsChange: "Cambio en los términos del contrato",
          houseRulesChange: "Cambio en las reglas del hogar",
          other: "Otro",
        },
        vehiclesTitle: "Vehículos",
        hasVehicles: "¿Tiene algún vehículo para registrar?",
        vehicleAnswerRequired: "Indique si tiene vehículos para registrar",
        vehicleListRequired: "Agregue al menos un vehículo",
        addVehicle: "Agregar vehículo",
        vehicleLabel: "Vehículo",
        vehicleYear: "Año",
        vehicleMake: "Marca",
        vehicleModel: "Modelo",
        vehicleColor: "Color",
        vehiclePlate: "Matrícula",
        vehiclePlatePattern:
          "Ingrese una matrícula válida — solo letras y números, hasta 10 caracteres, sin espacios",
        vehicleState: "Estado",
        vehicleYearRequired: "El año es requerido",
        vehicleMakeRequired: "La marca es requerida",
        vehicleModelRequired: "El modelo es requerido",
        petsTitle: "Mascotas y animales de servicio",
        hasPets:
          "¿Tiene mascotas, animales de servicio o animales de apoyo emocional?",
        addPet: "Agregar animal",
        removePet: "Eliminar animal",
        petLabel: "Animal",
        petCategory: "Tipo de animal",
        petCategoryPet: "Mascota",
        petCategoryService: "Animal de servicio",
        petCategoryEsa: "Animal de apoyo emocional (ESA)",
        petCategoryNoFeesNote:
          "Los animales de servicio y los ESA no están sujetos a renta, depósito ni tarifas de mascotas según las reglas de Vivienda Justa.",
        petName: "Nombre",
        petType: "Especie",
        petTypeDog: "Perro",
        petTypeCat: "Gato",
        petTypeOther: "Otro",
        petBreed: "Raza",
        petWeight: "Peso (lbs)",
        petColor: "Color",
        petNameRequired: "El nombre del animal es requerido",
        petTypeRequired: "La especie es requerida",
      },
      studentDetails: {
        title: "Certificación del Estado Estudiantil",
        subtitle: "Seleccione la opción que aplica a su hogar.",
        studentDefinition:
          "Un estudiante se define como alguien que asiste a la escuela a tiempo completo durante cualquier parte de cinco o más meses en un año calendario (los meses no necesitan ser consecutivos).",
        selectOption: "Por favor seleccione una opción",
        selected: "Seleccionado",
        change: "Cambiar",
        optionA:
          "Al menos un miembro del hogar no es estudiante, no ha sido estudiante y no lo será durante el año calendario actual y/o próximo.",
        optionAHelp: "",
        optionB:
          "Todos los miembros del hogar son estudiantes, pero al menos uno es estudiante de tiempo parcial.",
        optionBHelp:
          "Se requiere documentación del estado de estudiante de tiempo parcial para al menos un miembro del hogar.",
        optionC:
          "Todos los miembros del hogar son estudiantes de tiempo completo durante cinco o más meses del año calendario actual y/o próximo (los meses no necesitan ser consecutivos).",
        optionCHelp: "",
        exemptionsTitle: "Preguntas de Exención Estudiantil LIHTC",
        exemptionsSubtitle:
          "Dado que todos los miembros del hogar son estudiantes de tiempo completo, por favor responda cada pregunta a continuación.",
        yes: "Sí",
        no: "No",
        answerRequired: "Por favor responda esta pregunta",
        planningQuestion:
          "¿Algún miembro del hogar comenzará o continuará como estudiante de tiempo completo o parcial durante los próximos 12 meses?",
        planningHelp:
          "Incluya a cualquier persona que planee inscribirse en una escuela, universidad o programa de capacitación durante el próximo año.",
        fosterQuestion:
          "¿Vivirán en el hogar niños o adultos en cuidado de crianza (foster)?",
        fosterHelp:
          "Responda Sí si un niño o adulto en cuidado de crianza está ubicado con su hogar.",
        q1: "¿Al menos un estudiante recibe asistencia bajo el título IV de la Ley del Seguro Social (por ejemplo, pagos bajo AFDC)?",
        q2: "¿Al menos un estudiante estuvo previamente bajo el cuidado de una agencia responsable de administrar cuidado de crianza? (proporcione documentación de participación)",
        q3: "¿Al menos un estudiante participa en un programa que recibe asistencia bajo la Ley de Asociación para la Capacitación Laboral (JTPA), la Ley de Inversión en la Fuerza Laboral u otras leyes federales, estatales o locales similares? (adjunte documentación de participación)",
        q4: "¿Al menos un estudiante es padre soltero con hijo(s), y este padre no es dependiente de otra persona y el/los hijo(s) no son dependientes de alguien que no sea un padre?",
        q5: "¿Están los estudiantes casados y tienen derecho a presentar una declaración conjunta de impuestos?",
        eligibleTitle: "Elegible.",
        eligibleMessage:
          "Al menos una exención aplica — el hogar califica bajo las reglas estudiantiles de LIHTC.",
        ineligibleTitle: "Probablemente no elegible.",
        ineligibleMessage:
          "Según sus respuestas, el hogar probablemente no califica bajo las restricciones estudiantiles. Si tiene alguna pregunta o no estaba seguro de alguna de las respuestas, comuníquese con la oficina:",
        callUs: "Llámenos",
        emailUs: "Envíenos un correo",
        primaryAnswerNote:
          "El estado estudiantil indicado a continuación fue certificado por el solicitante principal. Si cree que es incorrecto, comuníquese con la oficina de la propiedad antes de continuar.",
        acknowledgeLabel:
          "Certifico que lo anterior es verdadero y completo según mi leal saber y entender.",
        acknowledgeRequired: "Debe confirmar antes de continuar",
        memberStudentStatus: {
          sectionTitle: "Estado Estudiantil — Cada Adulto",
          sectionSubtitle:
            "Para cada adulto en su hogar, indique si es estudiante a tiempo completo, estudiante a tiempo parcial o no es estudiante.",
          fullTime: "Estudiante de Tiempo Completo",
          partTime: "Estudiante de Tiempo Parcial",
          notStudent: "No es Estudiante",
          required: "Por favor seleccione un estado estudiantil",
        },
      },
      specialNeeds: {
        title: "Declaración de Necesidades Especiales",
        subtitle:
          "Algunas propiedades reservan unidades para hogares que incluyen una persona con una necesidad especial. Esta declaración es voluntaria — no se le pide divulgar detalles sobre el tipo o naturaleza de la necesidad.",
        categoriesIntro:
          "TDHCA define a una 'Persona con Necesidades Especiales' como alguien que pertenece a cualquiera de estas categorías:",
        categories: {
          alcoholDrugAddiction:
            "Hogares en los que un miembro tiene adicciones al alcohol o las drogas",
          coloniaResidents: "Residentes de colonias",
          personsWithDisabilities: "Personas con discapacidades",
          vawa: "Personas protegidas por la Ley de Violencia contra la Mujer (violencia doméstica, violencia de pareja, agresión sexual, acoso)",
          hivAids: "Personas con VIH/SIDA",
          homeless: "Personas sin hogar",
          veterans: "Veteranos",
          woundedWarriors:
            "Guerreros heridos (según la Ley Caring for Wounded Warriors de 2008)",
          farmworkers: "Trabajadores agrícolas",
        },
        disclosureNote:
          "Solo necesita indicar si alguien en su hogar cumple con una de las categorías anteriores — no cuál.",
        txVeteranNoticeTitle:
          "Información Importante para Ex Miembros del Servicio Militar",
        txVeteranNotice:
          "Las mujeres y los hombres que sirvieron en cualquier rama de las Fuerzas Armadas de los Estados Unidos, incluyendo la Fuerza Aérea, Ejército, Marina, Marines, Guardia Costera, Reservas o Guardia Nacional, pueden ser elegibles para beneficios y servicios adicionales. Para más información, visite el Portal de Veteranos de Texas en",
        question: "¿Su hogar incluye una persona con una necesidad especial?",
        optionYes:
          "Sí — al menos un miembro del hogar cumple con una categoría anterior",
        optionNo: "No — nadie en el hogar cumple con estas categorías",
        optionDecline: "No deseo proporcionar esta información",
        answerRequired: "Por favor seleccione una opción",
        veteranQuestion:
          "¿Es usted veterano de las Fuerzas Armadas de los EE. UU.?",
        veteranYes: "Sí",
        veteranNo: "No",
        veteranRequired: "Por favor responda esta pregunta",
        selected: "Seleccionado",
        primaryAnswerNote:
          "El solicitante principal ha respondido esta declaración en nombre del hogar. Si cree que es incorrecta, comuníquese con la oficina de la propiedad antes de continuar.",
        acknowledgeLabel:
          "Reconozco la respuesta del solicitante principal arriba.",
        acknowledgeRequired: "Debe reconocer antes de continuar",
      },
      specialStatus: {
        title: "Verificación de Estado Especial",
        question:
          "¿El jefe del hogar o su cónyuge tiene 62 años o más, o tiene alguna discapacidad?",
        yes: "Sí",
        no: "No",
        answerRequired: "Por favor responda esta pregunta",
        anticipatedAddition: {
          title: "Adición Anticipada al Hogar",
          question:
            "¿Alguien en el hogar está esperando un hijo, en proceso de adopción o de obtener la custodia de un menor?",
          helper:
            "Opcional. Responder Sí nos permite contar al integrante adicional del hogar para el límite de ingresos y el tamaño de la unidad.",
          answerRequired: "Por favor responda esta pregunta",
          selectAtLeastOne: "Por favor seleccione al menos una opción",
          expectingLabel: "Esperando un hijo (o hijos)",
          adoptingLabel: "En proceso de adoptar un hijo (o hijos)",
          custodyLabel:
            "En proceso de obtener la custodia de un hijo (o hijos)",
          dueDateLabel: "Fecha prevista de nacimiento",
          dueDateInvalid: "Ingrese una fecha válida en formato MM/DD/AAAA",
          dueDateRequired: "Por favor ingrese la fecha prevista de nacimiento",
          explanationLabel: "Comentarios / explicación (opcional)",
          explanationPlaceholder:
            "Agregue cualquier detalle que ayude a verificar la adición anticipada (por ejemplo, estado de adopción o custodia pendiente).",
        },
      },
      householdIncome: {
        yes: "Sí",
        no: "No",
        childSupportChildIdsLabel: "¿De qué menores tiene custodia?",
        childSupportChildIdsHelper:
          "Seleccione los menores en su hogar de quienes tiene 50% o más de custodia.",
        childSupportChildIdsRequired: "Por favor seleccione al menos un menor",
        childSupportStatusLabel:
          "¿Cuál describe su situación de manutención infantil?",
        childSupportStatusRequired: "Por favor seleccione una opción",
        childSupportStatusOptions: {
          a: "Ordenado por tribunal y actualmente recibiendo manutención",
          b: "Ordenado por tribunal, pero NO recibiendo y sin anticipar recibir manutención en los próximos 12 meses",
          c: "Sin orden judicial y sin documentación; sin embargo, sí recibo dinero en efectivo",
          d: "Nunca he recibido y sin orden judicial; sin embargo, anticipo recibir manutención en los próximos 12 meses",
          e: "Nunca he recibido, sin orden judicial y sin anticipar recibir manutención en los próximos 12 meses",
        },
        childSupportAmountLabel: "Monto",
        childSupportAmountLabelMonthly: "Monto (por mes)",
        childSupportAmountRequired: "Por favor ingrese un monto",
        childSupportAmountInvalid:
          "Ingrese un número válido (p. ej., 250 o 250.00)",
        benefitAmountLabel: "Monto mensual",
        benefitAmountPerMonth: "/ mes",
        benefitAmountHelper:
          "Ingrese el monto bruto mensual antes de deducciones.",
        benefitAmountRequired: "Por favor ingrese el monto mensual",
        benefitAmountInvalid:
          "Ingrese un número válido (p. ej., 1250 o 1250.00)",
        childSupportFrequencyLabel: "¿Con qué frecuencia?",
        childSupportFrequencyRequired: "Por favor seleccione una frecuencia",
        childSupportFrequencyOptions: {
          week: "Por semana",
          month: "Por mes",
          annually: "Anual",
        },
        employmentIncomeAmountLabel: "Monto bruto de salario",
        employmentIncomeAmountHelper:
          "Ingrese su salario bruto, horas extras, bonos y comisiones para el período seleccionado.",
        employmentIncomeAmountRequired:
          "Por favor ingrese su monto bruto de salario",
        employmentIncomeAmountInvalid:
          "Ingrese un número válido (p. ej., 2500 o 2500.00)",
        employmentIncomeFrequencyLabel: "¿Con qué frecuencia le pagan?",
        employmentIncomeFrequencyRequired:
          "Por favor seleccione la frecuencia de pago",
        employmentIncomeFrequencyOptions: {
          weekly: "Semanal",
          biWeekly: "Cada dos semanas",
          semiMonthly: "Dos veces al mes",
          monthly: "Mensual",
          annually: "Anual",
        },
        cashWorkAmountLabel: "Monto del trabajo en efectivo",
        cashWorkAmountHelper:
          "Ingrese el monto bruto que gana por trabajo en efectivo en cada período.",
        cashWorkAmountRequired: "Por favor ingrese un monto",
        cashWorkAmountInvalid:
          "Ingrese un número válido (p. ej., 250 o 250.00)",
        cashWorkFrequencyLabel: "¿Con qué frecuencia?",
        cashWorkFrequencyRequired: "Por favor seleccione una frecuencia",
        additionalJobs: {
          title: "Trabajos adicionales o ingresos extra",
          helper:
            "¿Tiene más de un trabajo o hace trabajo en efectivo / extra en otro lugar? Agréguelo aquí para que todos los ingresos queden listados.",
          add: "Agregar otro trabajo o ingreso extra",
          remove: "Quitar",
          jobLabel: "Trabajo {{n}}",
          kindLabel: "¿Qué tipo de ingreso es este?",
          kindRequired: "Por favor seleccione el tipo de ingreso",
          kindOptions: {
            wages: "Salario / sueldo (otro trabajo)",
            cashWork: "Trabajo en efectivo o ingreso extra",
            selfEmployment: "Trabajo independiente / freelance",
          },
          amountLabel: "Monto bruto",
          amountRequired: "Por favor ingrese un monto",
          amountInvalid: "Ingrese un número válido (p. ej., 250 o 250.00)",
          frequencyRequired: "Por favor seleccione una frecuencia",
        },
        recurringGift: {
          title: "¿Quién brinda esta ayuda?",
          helper:
            "Le enviaremos un correo directamente a esta persona para que verifique el monto y la frecuencia. Por las reglas de cadena de custodia de HUD, usted no verá ni completará la parte de ellos en el formulario — firmarán en su propia sesión.",
          sourceNameLabel: "Nombre completo",
          sourceNameRequired: "Por favor ingrese su nombre",
          sourceEmailLabel: "Correo electrónico",
          sourceEmailRequired: "Por favor ingrese su correo electrónico",
          sourceEmailInvalid: "Ingrese un correo electrónico válido",
          sourcePhoneLabel: "Teléfono (opcional)",
          sourcePhoneHelper:
            "Opcional — el personal puede usarlo como respaldo si no responden por correo.",
        },
        cashTip: {
          occupationLabel: "Puesto u ocupación",
          occupationPlaceholder: "p. ej. Mesero, Cantinero, Cajero",
          occupationRequired: "Por favor ingrese su puesto u ocupación",
          industryLabel: "Industria",
          industryRequired: "Por favor ingrese su industria",
          employerNameLabel: "Nombre del empleador",
          employerNameRequired: "Por favor ingrese el nombre de su empleador",
          employerAddressLabel: "Dirección del empleador",
          employerAddressRequired:
            "Por favor ingrese la dirección de su empleador",
          employerCityStateZipLabel:
            "Ciudad, estado y código postal del empleador",
          employerCityStateZipPlaceholder: "p. ej. Austin, TX 78701",
          employerCityStateZipRequired:
            "Por favor ingrese la ciudad, estado y código postal de su empleador",
          employerWorkPhoneLabel: "Número de teléfono del trabajo",
          employerWorkPhoneRequired:
            "Por favor ingrese su número de teléfono del trabajo",
          startDateLabel: "Fecha de inicio",
          startDateRequired: "Por favor ingrese su fecha de inicio",
          endDateLabel: "Fecha de finalización",
          currentlyEmployedLabel: "Actualmente trabajo aquí",
          supervisorNameLabel: "Nombre del supervisor",
          supervisorNameRequired:
            "Por favor ingrese el nombre de su supervisor",
          supervisorPhoneLabel: "Teléfono del supervisor",
          supervisorPhoneOptional: "Opcional",
          supervisorPhoneRequired:
            "Por favor ingrese el teléfono de su supervisor",
          statusLabel:
            "¿Cuál de estas opciones describe mejor su situación de propinas?",
          statusUnreported:
            "Recibo propinas en efectivo que NO reporto a mi empleador",
          statusReported:
            "Todas mis propinas están reportadas en mis recibos de pago",
          statusNone: "No estoy en un puesto que reciba propinas",
          statusRequired: "Por favor seleccione una opción",
          frequencyLabel: "¿Con qué frecuencia recibe estas propinas?",
          frequencyDaily: "Diariamente",
          frequencyWeekly: "Semanalmente",
          frequencyBiWeekly: "Quincenalmente",
          frequencySemiMonthly: "Dos veces al mes",
          frequencyMonthly: "Mensualmente",
          frequencyQuarterly: "Trimestralmente",
          frequencyAnnually: "Anualmente",
          frequencyRequired: "Por favor seleccione la frecuencia",
          amountLabel: "Monto promedio por período",
          amountHelper:
            "Promedio de propinas en efectivo por período, además de lo reportado en los recibos de pago.",
          amountInvalid:
            "Ingrese un monto válido (solo números, hasta 2 decimales)",
          amountRequired: "Por favor ingrese un monto",
          notTippedExplanationLabel: "Explique brevemente",
          notTippedExplanationPlaceholder:
            "p. ej. Asistente de oficina — no hay propinas de clientes en mi puesto",
          notTippedExplanationRequired:
            "Por favor explique brevemente por qué su puesto no recibe propinas",
        },
        hcv: {
          intro:
            "Algunas preguntas rápidas sobre su Vale de Elección de Vivienda. Esto nos ayuda a confirmar el tamaño aprobado de la unidad y a marcar cualquier fecha de portabilidad para que el vale no caduque a mitad del proceso.",
          hasVoucherLabel: "¿Tiene un Vale de Elección de Vivienda?",
          bedroomSizeLabel: "Tamaño aprobado de habitación en su vale",
          bedroomSizeRequired: "Por favor seleccione un tamaño aprobado",
          bedroomSize: {
            studio: "Estudio / Eficiencia",
            one: "1 habitación",
            two: "2 habitaciones",
            three: "3 habitaciones",
            four: "4 habitaciones",
            fivePlus: "5 o más habitaciones",
          },
          isPortingLabel:
            "¿Está portando su vale desde otra Autoridad de Vivienda?",
          isPortingHelper:
            "Portar significa que recibió su vale de una Autoridad de Vivienda Pública distinta y lo está trayendo a esta jurisdicción.",
          issuingPhaLabel: "Autoridad de Vivienda Pública emisora (opcional)",
          issuingPhaPlaceholder: "p. ej. Autoridad de Vivienda de Houston",
          issuingPhaHelper:
            "Nombre de la PHA que emitió su vale. Ayuda al personal a contactar al lugar correcto para la transferencia.",
          expiresLabel: "¿Cuándo expira su autorización de portabilidad?",
          expiresHelper:
            "De la documentación de portabilidad que le envió su PHA emisora. Un vale caducado a mitad del proceso significa que no podemos completar su mudanza.",
          expiresRequired:
            "Por favor ingrese la fecha de expiración de portabilidad",
          expiresInvalid: "Use el formato MM/DD/AAAA",
        },
        describeSource: "Describa esta fuente de ingresos",
        describePlaceholder: "Describa brevemente la fuente de este ingreso",
        describeRequired: "Por favor describa esta fuente de ingresos",
        requiredYesNo: "Por favor seleccione Sí o No",
        zeroIncomeMemberMismatch:
          "Parece que sí tiene algún ingreso — por favor regrese y seleccione las fuentes de ingresos que recibe antes de continuar.",
        groups: {
          // Primer pase — marco actual. Fuente de Sección A del certificado
          // de ingresos cero; también determina si se muestra la pantalla
          // de ingresos cero (y el segundo pase de próximos 12 meses).
          employment: {
            title: "Empleo y Trabajo por Cuenta Propia",
            subtitle: "¿Actualmente gana alguno de estos?",
          },
          cashTip: {
            title: "Ingresos por Propinas en Efectivo",
            subtitle:
              "LIHTC requiere que cada adulto empleado declare cómo recibe propinas — incluso si no recibe propinas en absoluto.",
          },
          cashWork: {
            title: "Ingresos por Trabajo en Efectivo",
            subtitle:
              "Díganos quién le paga y cuánto gana por trabajo en efectivo. LIHTC cuenta los ingresos en efectivo como ingresos, así que necesitamos estos datos.",
          },
          benefits: {
            title: "Beneficios Gubernamentales y Militares",
            subtitle: "¿Actualmente recibe alguno de estos beneficios?",
          },
          socialSecurity: {
            title: "Seguro Social y Discapacidad",
            subtitle: "¿Actualmente recibe alguno de estos?",
          },
          support: {
            title: "Apoyo y Asistencia",
            subtitle: "¿Actualmente recibe alguno de los siguientes?",
          },
          other: {
            title: "Otros Ingresos",
            subtitle: "¿Actualmente tiene alguna de estas fuentes de ingresos?",
          },
          zeroIncome: {
            title: "Sin Ingresos",
            subtitle:
              "No seleccionó ninguna fuente de ingresos actual. Por favor confirme que tiene cero ingresos actualmente.",
          },
          anyOther: {
            title: "¿Algún otro ingreso?",
            subtitle:
              "¿Alguna otra fuente de ingresos actual que no hayamos cubierto?",
          },
          hcv: {
            title: "Vale de Elección de Vivienda",
            subtitle:
              "Confirmar los detalles del vale ahora evita una autorización caducada a mitad del proceso.",
          },
          spousalStatus: {
            title: "Estado Conyugal",
            subtitle:
              "Estas preguntas documentan la elegibilidad de ingresos para vivienda asequible — su solicitud no será denegada por su estado civil.",
          },
          childSupportCert: {
            title: "Manutención de menores",
            subtitle:
              "LIHTC requiere esta certificación para cada adulto cuando hay menores en su hogar.",
          },
          // Segundo pase — solo se muestra cuando el solicitante confirmó cero
          // ingresos actuales. Misma lista de elementos, marco a futuro.
          // Alimenta la Sección B del certificado (pending_new_income).
          next12Intro:
            "Aunque no tiene ingresos actuales, díganos sobre cualquier ingreso que anticipa en los próximos 12 meses.",
          employmentNext12: {
            title: "Empleo — próximos 12 meses",
            subtitle: "¿Ganará alguno de estos en los próximos 12 meses?",
          },
          benefitsNext12: {
            title: "Beneficios Gubernamentales y Militares — próximos 12 meses",
            subtitle:
              "¿Recibirá alguno de estos beneficios en los próximos 12 meses?",
          },
          socialSecurityNext12: {
            title: "Seguro Social y Discapacidad — próximos 12 meses",
            subtitle: "¿Recibirá alguno de estos en los próximos 12 meses?",
          },
          supportNext12: {
            title: "Apoyo y Asistencia — próximos 12 meses",
            subtitle:
              "¿Recibirá alguno de los siguientes en los próximos 12 meses?",
          },
          otherNext12: {
            title: "Otros Ingresos — próximos 12 meses",
            subtitle:
              "¿Tendrá alguna de estas fuentes de ingresos en los próximos 12 meses?",
          },
          anyOtherNext12: {
            title: "Algún otro ingreso — próximos 12 meses",
            subtitle:
              "¿Alguna otra fuente de ingresos en los próximos 12 meses que no hayamos cubierto?",
          },
          // Sección C del certificado de ingresos cero — solo se muestra
          // cuando el solicitante tiene cero ingresos actuales Y cero
          // anticipados.
          expensesPaySources: {
            title: "¿Cómo pagará sus gastos?",
            subtitle:
              'Como no tiene ingresos actuales ni anticipados, indíquenos quién pagará cada gasto — escriba el nombre de la persona o entidad, o "N/A" si no aplica.',
          },
        },
        items: {
          employmentIncome: {
            title: "Sueldos, salario, propinas, horas extras",
            description:
              "Cualquier ingreso de nómina, incluidos bonos y comisiones",
          },
          selfEmployment: {
            title: "Trabajo por cuenta propia",
            description:
              "Ingresos de negocio, trabajo independiente, contratista",
          },
          cashWork: {
            title: "Trabajo por efectivo (niñera, jardinería)",
            description:
              "Limpieza de casa, reparaciones, u otros trabajos informales pagados en efectivo",
          },
          unemployment: {
            title: "Beneficios de desempleo",
            description: "Compensación estatal o federal por desempleo",
          },
          vaGiBill: {
            title: "Beneficios VA / GI Bill",
            description: "Beneficios de Asuntos de Veteranos o GI Bill",
          },
          militaryIncome: {
            title: "Ingreso militar",
            description:
              "Pago de servicio activo, pago de reserva, asignaciones",
          },
          publicAssistance: {
            title: "Asistencia pública",
            description: "TANF, GAU, programas de asistencia en efectivo",
          },
          ssRetirement: {
            title: "Jubilación del Seguro Social",
            description: "Beneficios de jubilación del Seguro Social",
          },
          ssiSsdi: {
            title: "SSI o SSDI",
            description:
              "Ingreso Suplementario del Seguro o Discapacidad del Seguro Social",
          },
          disabilityDeathBenefits: {
            title: "Beneficios por discapacidad/fallecimiento",
            description:
              "Beneficios por discapacidad o fallecimiento no del Seguro Social",
          },
          workersComp: {
            title: "Compensación del Trabajador",
            description: "Beneficios de L&I / Compensación del Trabajador",
          },
          cashAssistanceFromOthers: {
            title: "Asistencia en efectivo de otros",
            description:
              "Regalos regulares en efectivo de familia, amigos u organizaciones",
          },
          billPaymentHelp: {
            title: "Ayuda con el pago de cuentas",
            description:
              "Alguien paga regularmente sus cuentas (renta, servicios, etc.)",
          },
          trustsAnnuitiesPensions: {
            title: "Fideicomisos, anualidades, pensiones",
            description:
              "Ingresos de fideicomisos, anualidades, herencia o pensiones",
          },
          interestDividends: {
            title: "Intereses/dividendos de activos",
            description:
              "Intereses de cuentas de ahorro o CDs; dividendos de acciones, bonos o cuentas de inversión",
          },
          realEstatePropertyIncome: {
            title: "Ingresos de propiedad en alquiler",
            description:
              "Renta cobrada de una propiedad o unidad que usted posee",
          },
          onlineIncome: {
            title: "Ingresos en línea",
            description:
              "Economía gig, reventa, plataformas de trabajo independiente",
          },
          directSales: {
            title: "Ventas Directas (Mary Kay, etc.)",
            description:
              "Avon, Tupperware, doTERRA, u otros productos de venta directa / multinivel",
          },
          educationAssistance: {
            title: "Asistencia financiera educativa",
            description:
              "Becas, subvenciones, estipendios (más allá de la matrícula)",
          },
          unearnedIncomeMinors: {
            title: "Ingresos no ganados para menores",
            description:
              "Fondos fiduciarios, inversiones u otros ingresos para menores",
          },
          publicHousingSection8: {
            title: "Vivienda pública / Sección 8",
            description: "Vale de Elección de Vivienda o vivienda pública",
          },
          zeroIncomeMember: {
            title: "Sin ingresos de ninguna fuente",
            description:
              "Sin sueldo, sin beneficios, sin apoyo — nada actualmente",
          },
          otherIncomeNotListed: {
            title: "Cualquier otra fuente de ingresos",
            description:
              "Cualquier fuente de ingresos no cubierta en las pantallas anteriores",
          },
          pendingJobOffer: {
            title: "¿Ha aceptado una oferta de empleo que aún no ha comenzado?",
            description:
              "Marque Sí solo si tiene una carta de oferta firmada de un empleador específico y está esperando comenzar.",
          },
        },
        spousalStatus: {
          maritalStatusLabel: "Estado civil",
          maritalStatusRequired: "Por favor seleccione su estado civil",
          options: {
            Single: "Soltero/a",
            Married: "Casado/a",
            Separated: "Separado/a",
            Estranged: "Distanciado/a",
            Divorced: "Divorciado/a",
            Widowed: "Viudo/a",
          },
          certNotice:
            "Como seleccionó Separado/a o Distanciado/a, deberá firmar más adelante una Certificación de Separación/Distanciamiento Conyugal.",
          spouseNameLabel: "Nombre completo del cónyuge",
          spouseNameRequired: "Por favor ingrese el nombre de su cónyuge",
          separationDateLabel: "Fecha de separación (opcional)",
          estrangedConfirmText:
            "Estoy DISTANCIADO/A de mi cónyuge (aún no legalmente separado/a o divorciado/a). Él/ella no contribuirá económicamente y NO vivirá en el apartamento en ningún momento durante mi tenencia.",
          estrangedConfirmRequired:
            "Por favor confirme marcando la casilla anterior.",
          estrangedInitialsLabel: "Inicialice aquí",
          estrangedInitialsRequired: "Por favor ingrese sus iniciales",
          receivingContributionLabel:
            "¿Recibe alguna aportación conyugal para su hogar?",
          receivingContributionRequired: "Por favor responda sí o no",
          contributionAmountLabel:
            "Aportación conyugal mensual (anticipada para los próximos 12 meses)",
          contributionAmountHelper:
            "Se requiere verificación. Debe notificar a la oficina de inmediato cualquier cambio en este monto.",
          amountRequired: "Por favor ingrese el monto que recibe",
          anticipatedSpousalContributionLabel:
            "¿Espera recibir aportaciones conyugales en los próximos 12 meses?",
          anticipatedSpousalContributionRequired: "Por favor responda sí o no",
          awardedIncomeLabel:
            "¿Se le ha otorgado ingreso como pensión alimenticia, manutención de menores o beneficios de sobreviviente?",
          awardedIncomeRequired: "Por favor responda sí o no",
          anticipatedAwardedIncomeLabel:
            "¿Espera que se le otorgue pensión alimenticia, manutención de menores o beneficios de sobreviviente en los próximos 12 meses?",
          anticipatedAwardedIncomeRequired: "Por favor responda sí o no",
          possessLegalDocsLabel:
            "¿Tiene documentos legales (decreto de divorcio, acuerdo de separación) para verificar su estado?",
          possessLegalDocsRequired: "Por favor responda sí o no",
          noLegalDocsReasonLabel: "¿Por qué no tiene documentos legales?",
          noLegalDocsReasonRequired: "Por favor explique",
          legalActionsLabel:
            "¿Qué acciones legales ha tomado para cobrar los pagos que se le adeudan?",
          legalActionsPlaceholder:
            "p. ej. Presentado ante la Oficina del Procurador General; consulté con un abogado de familia; ninguna",
        },
        expensesPaySources: {
          placeholder: "Persona, entidad o N/A",
          fields: {
            rent: "Renta (incluyendo renta de garaje, si aplica)",
            utilities: "Servicios públicos",
            food: "Comida",
            clothing: "Ropa",
            schoolSupplies: "Útiles escolares",
            phone: "Celular o teléfono",
            tvInternet: "TV (cable, antena, satélite) y/o internet",
            medical: "Atención médica",
            medications: "Medicamentos y recetas",
            personalCare:
              "Productos de cuidado personal (champú, pasta dental, etc.)",
            vehicle:
              "Gastos de vehículo (pagos del auto, seguro, gasolina, etc.)",
            creditCards: "Pagos de saldos de tarjetas de crédito",
            other: "Otros gastos no listados arriba",
            additionalComments: "Comentarios adicionales",
          },
        },
      },
      assets: {
        yes: "Sí",
        no: "No",
        continue: "Continuar",
        back: "Atrás",
        groups: {
          financialAccounts: {
            title: "Cuentas Financieras",
            subtitle: "¿Tiene su hogar alguna de estas cuentas?",
          },
          investmentsInsurance: {
            title: "Inversiones y Seguros",
            subtitle: "¿Posee su hogar alguno de estos?",
          },
          otherAssets: {
            title: "Otros Activos",
            subtitle: "¿Su hogar tiene alguno de estos?",
          },
          disposedAssets: {
            title: "Activos Dispuestos — Últimos 2 Años",
            subtitle:
              "Liste cada activo que usted o cualquier miembro de su hogar regaló o vendió por menos del valor justo de mercado en los últimos 2 años. Hasta 3 entradas.",
          },
        },
        disposed: {
          rowLabel: "Activo {{n}}",
          removeRow: "Eliminar este activo",
          typeLabel: "Tipo de activo",
          typePlaceholder: "p. ej. Honda Civic 2018",
          fairMarketValueLabel: "Valor justo de mercado",
          actualAmountReceivedLabel: "Cantidad real recibida",
          dateOfDisposalLabel: "Fecha de disposición",
          dateOfDisposalHelper:
            "Debe estar dentro de los últimos 2 años (ventana de cumplimiento LIHTC).",
          dateOutOfRange:
            "La fecha de disposición debe estar dentro de los últimos 2 años (y no en el futuro).",
          explanationLabel: "Explicación",
          explanationPlaceholder:
            "p. ej. Auto regalado a mi hermano por dificultades médicas",
          addFirstRow: "+ Agregar activo dispuesto",
          addAnotherRow: "+ Agregar otro activo ({{remaining}} restantes)",
          atLeastOneRowRequired: "Por favor liste al menos un activo dispuesto",
          maxRowsExceeded:
            "Puede listar hasta 3 activos aquí. Use el campo de explicación para cualquier activo adicional.",
          rowFieldRequired: "Este campo es obligatorio",
          currencyInvalid:
            "Ingrese una cantidad válida (solo dígitos, p. ej. 1250 o 1250.50)",
          dateInvalid: "Seleccione una fecha válida",
          explanationRequired:
            "Por favor explique brevemente por qué se dispusieron estos activos",
        },
        items: {
          checking: {
            title: "Cuenta(s) de cheques",
            description: "Cuentas de cheques personales o conjuntas",
          },
          savings: {
            title: "Cuenta(s) de ahorros",
            description: "Cuentas de ahorros personales o conjuntas",
          },
          internetBased: {
            title: "Activos en plataformas digitales",
            description: "Saldos de Cash App, Venmo, PayPal, Apple Pay",
          },
          debitCards: {
            title: "Tarjetas de débito (no vinculadas al banco)",
            description: "Tarjetas de débito prepagadas o recargables",
          },
          moneyMarket: {
            title: "Cuentas del mercado monetario",
            description: "Cuentas de depósito del mercado monetario",
          },
          cashOnHand: {
            title: "Efectivo en mano",
            description:
              "Dinero en efectivo en posesión de cualquier miembro del hogar",
          },
          brokerage: {
            title: "Cuentas de corretaje",
            description: "Cuentas de corretaje de inversiones",
          },
          capitalInvestments: {
            title: "Inversiones de capital",
            description: "Participaciones en negocios o inversiones de capital",
          },
          stocks: {
            title: "Acciones",
            description: "Acciones individuales, fondos mutuos o ETFs",
          },
          bonds: {
            title: "Bonos",
            description: "Bonos gubernamentales, corporativos o municipales",
          },
          annuities: {
            title: "Anualidades",
            description: "Contratos de anualidad fijos o variables",
          },
          cds: {
            title: "Certificado de Depósito",
            description: "CDs en bancos o cooperativas de crédito",
          },
          cryptocurrency: {
            title: "Criptomonedas",
            description: "Bitcoin, Ethereum u otras monedas digitales",
          },
          lifeInsurance: {
            title: "Seguro de vida (no-término)",
            description: "Pólizas de vida entera, universal o vida variable",
          },
          trustFunds: {
            title: "Fondos fiduciarios",
            description:
              "Fondos fiduciarios bajo el control de un miembro del hogar",
          },
          lumpSumAmounts: {
            title: "Montos de suma global",
            description: "Ganancias de lotería, herencia, acuerdos de seguro",
          },
          safetyDepositBox: {
            title: "Contenido de caja de seguridad",
            description: "Objetos de valor guardados en una caja de seguridad",
          },
          realEstateProperty: {
            title: "Bienes raíces",
            description: "Terreno o propiedad de miembros del hogar",
          },
          landContracts: {
            title: "Hipotecas o contratos de terreno que usted posee",
            description:
              "Un pagaré o contrato de terreno en el que un comprador le hace pagos a usted — p. ej. vendió una propiedad y financia el préstamo usted mismo",
          },
          taxRefund: {
            title: "Reembolso de impuestos estatales (últimos 12 meses)",
            description:
              "Un reembolso de impuestos estatales que aún tiene en sus cuentas o en efectivo. (Los reembolsos federales se tratan en la siguiente pregunta.)",
          },
          crowdsourcing: {
            title: "GoFundMe / Recaudación colectiva",
            description:
              "Saldo de GoFundMe, Kickstarter o cualquier campaña de recaudación en línea",
          },
          assetsGivenAway: {
            title: "Activos regalados por debajo del valor",
            description:
              "Activos vendidos o regalados por debajo del valor justo de mercado (últimos 2 años)",
          },
          personalPropertyInvestment: {
            title: "Propiedad personal como inversión",
            description:
              "Coleccionables, arte, vehículos u otra propiedad personal con valor de inversión",
          },
          otherAssetsNotListed: {
            title: "Otros activos",
            description: "Cualquier otro activo no listado arriba",
          },
        },
        requiredYesNo: "Por favor seleccione Sí o No",
        personalPropertyExplanationLabel: "Describa la propiedad personal",
        personalPropertyExplanationPlaceholder:
          "p. ej. Mustang 1968 restaurado — conservado por su valor de inversión",
        personalPropertyExplanationRequired:
          "Por favor describa la propiedad personal",
        otherAssetExplanationLabel: "Describa los otros activos",
        otherAssetExplanationPlaceholder:
          "p. ej. Monedas de oro heredadas, equipo de negocio fuera de una empresa",
        otherAssetExplanationRequired: "Por favor describa los otros activos",
        value: {
          cashValueLabel: "Valor actual",
          interestRateLabel: "Tasa de interés",
          annualIncomeLabel: "Ingreso anual",
          dividendIncomeLabel: "Dividendos / distribuciones anuales",
          rentalIncomeLabel: "Ingreso neto anual por alquiler",
          dividendIncomeHelper:
            "Total de dividendos o distribuciones que estos activos pagaron en el último año (ingrese 0 si no hay).",
          declaredIncomeRequired:
            "Ingrese el ingreso anual (ingrese 0 si no hay)",
          institutionLabel: "Banco / institución",
          institutionPlaceholder: "p. ej. Chase, Fidelity, MetLife",
          institutionRequired:
            "Ingrese el banco o la institución donde está este activo",
          accountLabel: "Cuenta / póliza n.º",
          accountPlaceholder: "Los últimos 4 dígitos son suficientes",
          accountRequired:
            "Ingrese el número de cuenta o póliza (los últimos 4 son suficientes)",
          accountN: "Cuenta {{n}}",
          removeAccount: "Eliminar cuenta",
          addAccount: "+ Agregar otra {{asset}}",
          accountSubtotal: "Subtotal: {{cash}}  ·  {{income}}/año",
          accountSubtotalCashOnly: "Subtotal: {{cash}}",
          cashValueRequired: "Ingrese el valor actual de la cuenta",
          interestRateRequired:
            "Ingrese la tasa de interés (ingrese 0 si no hay)",
          interestRateInvalid: "Ingrese una tasa válida (p. ej. 1.5)",
          runningTotalLabel: "Total de activos",
          underThreshold:
            "Está por debajo de {{threshold}}: no necesitará subir estados de cuenta de activos.",
          overThreshold:
            "Está por encima de {{threshold}}: deberá subir estados de cuenta de sus cuentas.",
        },
        refund: {
          title: "Reembolso de impuestos federales",
          question:
            "¿Recibió un reembolso de impuestos federales o un crédito tributario reembolsable en los últimos 12 meses?",
          amountLabel: "¿Cuánto de ese reembolso permanece en sus cuentas hoy?",
          amountHelper:
            "Los reembolsos federales no cuentan como activos durante 12 meses, por lo que restamos este monto (regla de HUD).",
          receivedRequired: "Por favor responda Sí o No",
          amountRequired:
            "Ingrese el monto que aún conserva (ingrese 0 si no queda nada)",
          amountInvalid: "Ingrese un monto válido (p. ej. 1200.00)",
          grossLabel: "Activos brutos",
          lessRefundLabel: "Menos reembolso federal conservado",
          countableLabel: "Activos contables",
        },
      },
      financialSummary: {
        title: "Resumen Financiero",
        subtitleSingular:
          "Según sus respuestas, identificamos {{count}} elemento.",
        subtitlePlural:
          "Según sus respuestas, identificamos {{count}} elementos.",
        sectionIncome: "FUENTES DE INGRESOS",
        sectionAssets: "ACTIVOS",
        emptyState: "No se seleccionaron elementos de ingresos ni activos.",
        benefitsIncomeLabel: "Ingresos por beneficios declarados",
        perMonthSuffix: "/ mes",
        verificationNotice:
          "Le pediremos documentos de verificación para estos elementos en el siguiente paso.",
      },
      uploadCenter: {
        required: "Requerido",
        optional: "Opcional",
        incompleteRequired:
          "Cargue todos los documentos requeridos antes de continuar.",
        canSubmitLater:
          "No tiene que cargar todo ahora. Para continuar sin cargar, marque la casilla a continuación para que nuestro equipo sepa que desea ayuda; puede llevar sus documentos a la oficina o cargarlos más tarde.",
        needHelpCheckbox: "Me gustaría recibir ayuda con mis documentos",
        dragDrop: "Arrastre y suelte o",
        browse: "buscar",
        acceptHint: "PDF, JPG o PNG (máx {{maxMb}}MB)",
        oneDocument: "1 documento",
        nDocuments: "{{count}} documentos",
        upToNDocuments: "Hasta {{count}} documentos",
        downloadTemplate: "Descargar plantilla",
        legibility: {
          checking: "Verificando la calidad de la imagen…",
          warn: "Este archivo puede ser difícil de leer; se recomienda un escaneo más claro.",
          fail: "Este archivo se ve demasiado borroso o de baja resolución para leerse. Reemplácelo con un escaneo más claro.",
          unsupported:
            "No pudimos leer este archivo. Cargue un PDF, JPG, PNG o HEIC.",
        },
        universalRules: {
          title: "Antes de subir",
          freshness:
            "Cada documento debe tener una fecha dentro de los 120 días de su fecha de mudanza. Si el proceso toma tiempo, podemos pedir recibos de pago y estados de cuenta bancarios más recientes.",
          quality:
            "Por favor evite fotos borrosas del teléfono. Use una aplicación de escaneo gratuita (Adobe Scan, Genius Scan) para crear PDFs claros de varias páginas.",
        },
        sections: {
          standard: "DOCUMENTOS ESTÁNDAR",
          income: "DOCUMENTOS DE VERIFICACIÓN DE INGRESOS",
          asset: "DOCUMENTOS DE VERIFICACIÓN DE ACTIVOS",
        },
        groups: {
          standard: {
            title: "Prueba de Identidad y Composición del Hogar",
            subtitle: "Requerido para cada solicitud.",
          },
          employmentIncome: {
            title: "Verificación de Ingresos por Empleo",
            subtitle: "Según su ingreso reportado: Ingreso por empleo",
          },
          selfEmployment: {
            title: "Verificación de Trabajo por Cuenta Propia",
            subtitle: "Según su ingreso reportado: Trabajo por cuenta propia",
          },
          unemployment: {
            title: "Verificación de Beneficios de Desempleo",
            subtitle: "Según su ingreso reportado: Beneficios de desempleo",
          },
          vaGiBill: {
            title: "Verificación de Beneficios VA / GI Bill",
            subtitle: "Según su ingreso reportado: Beneficios VA / GI Bill",
          },
          militaryIncome: {
            title: "Verificación de Ingreso Militar",
            subtitle: "Según su ingreso reportado: Ingreso militar",
          },
          publicAssistance: {
            title: "Verificación de Asistencia Pública",
            subtitle: "Según su ingreso reportado: Asistencia pública",
          },
          ssRetirement: {
            title: "Verificación de Jubilación del Seguro Social",
            subtitle:
              "Según su ingreso reportado: Jubilación del Seguro Social",
          },
          ssiSsdi: {
            title: "Verificación de SSI / SSDI",
            subtitle: "Según su ingreso reportado: SSI o SSDI",
          },
          disabilityDeathBenefits: {
            title: "Verificación de Beneficios por Discapacidad/Fallecimiento",
            subtitle:
              "Según su ingreso reportado: Beneficios por discapacidad/fallecimiento",
          },
          workersComp: {
            title: "Verificación de Compensación del Trabajador",
            subtitle: "Según su ingreso reportado: Compensación del Trabajador",
          },
          childSupport: {
            title: "Verificación de Manutención de Hijos",
            subtitle:
              "Según su ingreso reportado: Pagos de manutención de hijos",
          },
          alimonySpousalSupport: {
            title: "Verificación de Pensión Alimenticia / Manutención Conyugal",
            subtitle:
              "Según su ingreso reportado: Pensión alimenticia / manutención conyugal",
          },
          cashAssistanceFromOthers: {
            title: "Verificación de Asistencia en Efectivo",
            subtitle:
              "Según su ingreso reportado: Asistencia en efectivo de otros",
          },
          billPaymentHelp: {
            title: "Verificación de Ayuda con Pago de Cuentas",
            subtitle:
              "Según su ingreso reportado: Ayuda con el pago de cuentas",
          },
          trustsAnnuitiesPensions: {
            title: "Verificación de Fideicomisos, Anualidades, Pensiones",
            subtitle:
              "Según su ingreso reportado: Fideicomisos, anualidades, pensiones",
          },
          realEstatePropertyIncome: {
            title: "Verificación de Ingresos de Bienes Raíces",
            subtitle:
              "Según su ingreso reportado: Bienes raíces / ingresos de propiedad",
          },
          onlineIncome: {
            title: "Verificación de Ingresos en Línea",
            subtitle: "Según su ingreso reportado: Ingresos en línea",
          },
          educationAssistance: {
            title: "Verificación de Asistencia Educativa",
            subtitle:
              "Según su ingreso reportado: Asistencia financiera educativa",
          },
          unearnedIncomeMinors: {
            title: "Verificación de Ingresos No Ganados para Menores",
            subtitle:
              "Según su ingreso reportado: Ingresos no ganados para menores",
          },
          publicHousingSection8: {
            title: "Verificación de Vivienda Pública / Sección 8",
            subtitle:
              "Según su ingreso reportado: Vivienda pública / Sección 8",
          },
          zeroIncomeMember: {
            title: "Verificación de Sin Ingresos",
            subtitle:
              "Según su ingreso reportado: Miembro del hogar sin ingresos",
          },
          otherIncomeNotListed: {
            title: "Verificación de Otros Ingresos",
            subtitle: "Según su ingreso reportado: Otros ingresos no listados",
          },
          // Grupo de Asistente Residente
          liveInAide: {
            title: "Documentación del Asistente Residente",
            subtitle:
              "Requerido porque su hogar incluye un Asistente Residente.",
          },
          checking: {
            title: "Verificación de Cuenta de Cheques",
            subtitle: "Según su activo reportado: Cuenta(s) de cheques",
          },
          savings: {
            title: "Verificación de Cuenta de Ahorros",
            subtitle: "Según su activo reportado: Cuenta(s) de ahorros",
          },
          internetBased: {
            title: "Verificación de Activos Digitales",
            subtitle:
              "Según su activo reportado: Activos en plataformas digitales",
          },
          debitCards: {
            title: "Verificación de Tarjetas de Débito",
            subtitle:
              "Según su activo reportado: Tarjetas de débito (no vinculadas al banco)",
          },
          moneyMarket: {
            title: "Verificación de Mercado Monetario",
            subtitle:
              "Según su activo reportado: Cuentas del mercado monetario",
          },
          brokerage: {
            title: "Verificación de Cuentas de Corretaje",
            subtitle: "Según su activo reportado: Cuentas de corretaje",
          },
          capitalInvestments: {
            title: "Verificación de Inversiones de Capital",
            subtitle: "Según su activo reportado: Inversiones de capital",
          },
          stocksBonds: {
            title: "Verificación de Acciones / Bonos",
            subtitle: "Según su activo reportado: Acciones / Bonos",
          },
          annuities: {
            title: "Verificación de Anualidades",
            subtitle: "Según su activo reportado: Anualidades",
          },
          cds: {
            title: "Verificación de Certificado de Depósito",
            subtitle: "Según su activo reportado: Certificado de Depósito",
          },
          cryptocurrency: {
            title: "Verificación de Criptomonedas",
            subtitle: "Según su activo reportado: Criptomonedas",
          },
          lifeInsurance: {
            title: "Verificación de Seguro de Vida",
            subtitle: "Según su activo reportado: Seguro de vida (no-término)",
          },
          trustFunds: {
            title: "Verificación de Fondos Fiduciarios",
            subtitle: "Según su activo reportado: Fondos fiduciarios",
          },
          lumpSumAmounts: {
            title: "Verificación de Suma Global",
            subtitle: "Según su activo reportado: Montos de suma global",
          },
          safetyDepositBox: {
            title: "Verificación de Caja de Seguridad",
            subtitle:
              "Según su activo reportado: Contenido de caja de seguridad",
          },
          realEstateProperty: {
            title: "Verificación de Bienes Raíces",
            subtitle: "Según su activo reportado: Bienes raíces",
          },
          taxRefund: {
            title: "Verificación de Reembolso de Impuestos Estatales",
            subtitle:
              "Según su activo reportado: Reembolso de impuestos estatales (últimos 12 meses)",
          },
          assetsGivenAway: {
            title: "Verificación de Activos Regalados",
            subtitle:
              "Según su activo reportado: Activos regalados por debajo del valor",
          },
          otherAssetsNotListed: {
            title: "Verificación de Otros Activos",
            subtitle: "Según su activo reportado: Otros activos",
          },
        },
        documents: {
          photoId: {
            title: "Identificación con Foto Emitida por el Gobierno",
            description:
              "Licencia de conducir, pasaporte o identificación estatal para cada miembro adulto del hogar",
          },
          ssCard: {
            title: "Tarjeta del Seguro Social",
            description:
              "Tarjeta original para cada miembro del hogar, incluidos bebés",
          },
          birthCertificate: {
            title: "Acta de Nacimiento",
            description: "Para cada menor en el hogar",
          },
          offerLetter: {
            title: "Carta de Oferta de Empleo",
            description:
              "Carta de oferta firmada para un puesto que ha aceptado pero aún no ha comenzado.",
          },
          custodyOrder: {
            title: "Orden Judicial de Custodia",
            description:
              "Orden judicial actual que muestra el arreglo de custodia para este menor.",
          },
          studentStatusProof: {
            title: "Prueba de Estado Estudiantil",
            description:
              "Transcripción escolar o carta del registrador que verifique la inscripción a tiempo completo o parcial",
          },
          divorceSeparationPapers: {
            title: "Documentos de Divorcio / Separación",
            description:
              "Para verificar el derecho a pensión alimenticia o manutención de hijos",
          },
          payStubs: {
            title: "Recibos de Pago",
            description:
              "Recibos de pago de los 60 días consecutivos más recientes. Si tiene una brecha, suba una nota breve explicándola.",
          },
          employmentVerificationLetter: {
            title: "Verificación de Empleo (VOE) o Carta de Oferta",
            description:
              "Requerida junto con los recibos de pago. Suba uno de: (a) una carta de verificación de empleo (VOE) de su empleador confirmando puesto, horas y salario, o (b) una carta de oferta firmada para un nuevo puesto que haya aceptado recientemente. La vivienda asequible es un compromiso a largo plazo — su empleador debería poder emitir una VOE a solicitud.",
          },
          federalTaxReturn: {
            title: "Declaración de Impuestos Federal (Formulario 1040)",
            description: "Año más reciente — todas las páginas y anexos",
          },
          profitAndLoss: {
            title: "Ganancias y Pérdidas del Año a la Fecha",
            description: "Estado P&G del año a la fecha de su negocio",
          },
          unemploymentBenefitStatement: {
            title: "Carta de Beneficios o Historial de Pagos de Desempleo",
            description:
              "Carta de beneficios o historial de pagos de su agencia estatal de desempleo (p. ej., EDD, ESD, DWS, Comisión de Fuerza Laboral).",
          },
          vaBenefitAwardLetter: {
            title: "Carta de Concesión de Beneficios VA",
            description: "Carta de concesión de beneficios VA más reciente",
          },
          les: {
            title: "Estado de Licencia y Ganancias (LES)",
            description: "LES más reciente",
          },
          publicAssistanceVerification: {
            title: "Verificación de Asistencia Pública",
            description: "De la agencia emisora (TANF, GAU, etc.)",
          },
          ssBenefitLetter: {
            title: "Carta de Beneficios del Seguro Social",
            description:
              "Carta del año actual mostrando el beneficio mensual bruto",
          },
          ssaBenefitAwardLetter: {
            title: "Carta de Concesión SSI / SSDI",
            description:
              "Para SSI: suba la carta de concesión o recertificación más ACTUAL (emitida dentro de los últimos 60 días) — los beneficios de SSI pueden cambiar durante el año. Para SSDI: la carta anual del año actual mostrando el beneficio mensual bruto es aceptable.",
          },
          disabilityDeathBenefitLetter: {
            title: "Carta de Concesión de Beneficios",
            description: "De la fuente emisora (no-SS)",
          },
          workersCompBenefitLetter: {
            title:
              "Carta de Beneficios, Concesión o Historial de Pagos de Compensación del Trabajador",
            description:
              "Documento más reciente de su aseguradora estatal de compensación del trabajador (p. ej., L&I, DWC, DIR) mostrando el monto del beneficio y la duración.",
          },
          workersCompAwardDoc: {
            title: "Documentación de Concesión de Compensación del Trabajador",
            description: "Mostrando monto y duración de la concesión",
          },
          childSupportOagPrintout: {
            title: "Historial de Pagos OAG",
            description:
              "Impresión de la Oficina del Procurador General mostrando los últimos 12 meses de pagos (incluso si $0.00)",
          },
          childSupportCashContributionVerification: {
            title: "Verificación de Contribución en Efectivo y Regalos",
            description:
              "Verificación firmada que cubre la manutención de hijos en efectivo recibida cuando no existe orden judicial / documentación",
          },
          childSupportAttorneyLetter: {
            title: "Carta del Abogado — Manutención Anticipada",
            description:
              "Carta de su abogado indicando el monto anticipado de manutención de hijos que espera recibir en los próximos 12 meses",
          },
          childSupportAffidavit: {
            title: "Declaración Jurada de Manutención de Hijos",
            description:
              "Declaración jurada firmada que atestigua la recepción de manutención (usada si no existe orden judicial / registro OAG)",
          },
          alimonyDecree: {
            title: "Decreto de Divorcio u Orden Judicial",
            description: "Documento que establece la obligación de manutención",
          },
          alimonyPaymentHistory: {
            title: "Historial de Pagos de Pensión Alimenticia",
            description:
              "Evidencia de pagos recibidos durante los últimos 6 meses",
          },
          annuityPensionStatement: {
            title: "Estado de Anualidad / Pensión / Jubilación",
            description:
              "Estado más reciente mostrando el monto bruto de distribución",
          },
          trustDocument: {
            title: "Documento de Fideicomiso",
            description: "Para ingresos relacionados con fideicomiso",
          },
          leaseAgreement: {
            title: "Contrato de Arrendamiento",
            description: "Contrato de arrendamiento del inquilino actual",
          },
          scheduleE: {
            title: "Anexo E",
            description: "De la declaración de impuestos federal más reciente",
          },
          form1099: {
            title: "Formulario 1099-NEC o 1099-K",
            description: "Formulario 1099 del año actual",
          },
          platformEarningsStatement: {
            title: "Estado de Ganancias de la Plataforma",
            description: "De la plataforma gig, últimos 3 meses",
          },
          educationAwardLetter: {
            title: "Carta de Concesión",
            description: "De la escuela o institución",
          },
          minorTrustStatement: {
            title: "Estado de Fondo Fiduciario / Inversión",
            description: "Para la cuenta del menor",
          },
          housingAuthorityLetter: {
            title: "Carta de Aprobación de Autoridad de Vivienda",
            description: "De la autoridad de vivienda emisora",
          },
          otherIncomeDocumentation: {
            title: "Documentación de Respaldo",
            description: "Describiendo la fuente de ingresos no listada arriba",
          },
          checkingStatements: {
            title: "Estados de Cuenta de Cheques",
            description:
              "Todas las páginas de los 6 meses consecutivos más recientes",
          },
          savingsStatement: {
            title: "Estado de Cuenta de Ahorros",
            description: "Mes más reciente, todas las páginas",
          },
          internetAssetStatement: {
            title: "Captura de Saldo o Estado de Cuenta",
            description:
              "Saldo del mes actual para Cash App, Venmo, PayPal o Apple Pay",
          },
          debitCardValueVerification: {
            title: "Verificación de Valor o Captura de Saldo",
            description:
              "Para débito prepagado (Direct Express, Netspend, etc.) — captura del cajero o aplicación",
          },
          moneyMarketStatement: {
            title: "Estado de Cuenta del Mercado Monetario",
            description: "Estado de cuenta más reciente",
          },
          brokerageStatement: {
            title: "Estado de Cuenta de Corretaje",
            description: "Estado más reciente de la cuenta de corretaje",
          },
          capitalInvestmentOwnership: {
            title: "Documentación de Propiedad",
            description: "Acuerdo operativo o registros de accionistas",
          },
          capitalInvestmentValuation: {
            title: "Estado de Valuación",
            description: "Valuación más reciente de la inversión",
          },
          stocksStatement: {
            title: "Estado de Acciones",
            description:
              "Estado de cuenta de corretaje mostrando las tenencias actuales",
          },
          bondsStatement: {
            title: "Estado de Bonos",
            description:
              "Estado de cuenta de bonos o certificado mostrando el valor nominal",
          },
          annuityContractOrStatement: {
            title: "Contrato de Anualidad o Estado de Cuenta",
            description: "Contrato de anualidad o estado más reciente",
          },
          cdStatement: {
            title: "Estado de Certificado de Depósito",
            description: "Mostrando saldo actual y plazo",
          },
          cryptoBalanceScreenshot: {
            title: "Estado de Cuenta Actual del Exchange o Billetera",
            description:
              "Estado de cuenta más reciente (PDF preferido) del exchange o billetera mostrando el saldo actual y las transacciones recientes. Las capturas de pantalla solo se aceptan si no hay un estado de cuenta descargable disponible.",
          },
          lifeInsuranceCashValue: {
            title: "Estado de Valor en Efectivo",
            description: "De la póliza de seguro de vida",
          },
          trustAgreement: {
            title: "Documento / Acuerdo de Fideicomiso",
            description: "Acuerdo de fideicomiso",
          },
          trustAccountStatement: {
            title: "Estado de Cuenta de Fideicomiso",
            description: "Estado más reciente de la cuenta de fideicomiso",
          },
          lumpSumSourceDocumentation: {
            title: "Documentación de la Fuente",
            description:
              "Carta de concesión, estado de acuerdo o carta del albacea",
          },
          safetyDepositContentsList: {
            title: "Lista Detallada del Contenido",
            description: "Firmada por un miembro del hogar",
          },
          safetyDepositBankVerification: {
            title: "Verificación Bancaria de Caja de Seguridad",
            description: "Del banco",
          },
          realEstateTaxAppraisal: {
            title: "Tasación de Impuestos",
            description: "Tasación de impuestos más reciente",
          },
          mortgageStatement: {
            title: "Estado de Hipoteca",
            description: "Estado de hipoteca actual",
          },
          landContractDocument: {
            title: "Documento de Contrato de Terreno",
            description:
              "Contrato de terreno firmado mostrando términos y precio de compra",
          },
          landContractPaymentLedger: {
            title: "Registro de Pagos",
            description: "Registro de pagos recibidos del comprador",
          },
          crowdsourcingPayoutStatement: {
            title: "Estado de Pago de Campaña / Registro de Depósito",
            description:
              "Estado de pago de GoFundMe u otra plataforma, o depósito bancario mostrando lo recaudado",
          },
          personalPropertyAppraisal: {
            title: "Tasación o Valuación",
            description:
              "Tasación profesional, recibo o valuación escrita del artículo",
          },
          taxRefundTranscript: {
            title: "Transcripción de Reembolso o Registro de Depósito",
            description:
              "Transcripción de reembolso del IRS o estatal, o estado de depósito bancario",
          },
          otherAssetDocumentation: {
            title: "Documentación de Respaldo",
            description: "Describiendo el activo no listado arriba",
          },
          // Documentos del Asistente Residente
          liaQuestionnaire: {
            title: "Cuestionario del Asistente Residente",
            description:
              "Cuestionario completado que se usa para la verificación de antecedentes penales del Asistente Residente. Descargue la plantilla en blanco, complétela y suba la copia firmada.",
          },
          liaNeedVerification: {
            title: "Verificación de Necesidad del Asistente Residente",
            description:
              "Documentación de un profesional calificado que verifica que el Asistente Residente es necesario para ayudar a un miembro del hogar con una necesidad relacionada con una discapacidad.",
          },
        },
      },
      reviewSign: {
        title: "Revisar y Firmar",
        subtitle:
          "Por favor revise la información a continuación antes de enviar su solicitud.",
        householdMembers: "Miembros del hogar",
        noHouseholdMembers: "No se agregaron miembros adicionales del hogar.",
        notAnswered: "Sin respuesta",
        noneSelected: "Ninguno seleccionado.",
        documentsCount_one: "{{count}} documento",
        documentsCount_other: "{{count}} documentos",
        needsDocumentHelpLabel: "Ayuda con documentos",
        needsDocumentHelpValue:
          "Solicitó ayuda para cargar sus documentos — nuestro equipo se comunicará con usted.",
        unitLease: {
          title: "Unidad y Contrato",
          unit: "Unidad",
          rent: "Renta mensual",
          moveInDate: "Fecha de mudanza",
          term: "Plazo del contrato",
          termMonths_one: "{{count}} mes",
          termMonths_other: "{{count}} meses",
        },
        address: "Dirección",
        employment: "Empleo",
        noVehicles: "No se registraron vehículos.",
        emergencyContactDeclined:
          "Optó por no proporcionar un contacto de emergencia.",
        yesNo: { yes: "Sí", no: "No" },
        studentStatus: {
          A: "Opción A — Al menos un miembro del hogar no es estudiante",
          B: "Opción B — Todos los miembros del hogar son estudiantes, al menos uno de tiempo parcial",
          C: "Opción C — Todos los miembros del hogar son estudiantes de tiempo completo",
        },
        certification: {
          title: "Certificación",
          label:
            "Certifico que toda la información proporcionada arriba es verdadera, precisa y completa según mi leal saber y entender.",
        },
        terms: {
          title: "Términos y Condiciones",
          body: "Al enviar esta solicitud, usted acepta lo siguiente:\n\n1. La información proporcionada es precisa y completa. Cualquier declaración falsa puede resultar en la denegación de la solicitud o la terminación del arrendamiento.\n\n2. Usted autoriza la verificación de sus ingresos, activos, empleo, crédito, historial criminal e historial de alquiler por parte de la administración de la propiedad y sus agentes.\n\n3. Las tarifas de solicitud no son reembolsables.\n\n4. Esta solicitud no garantiza la aprobación. La aprobación final está sujeta al cumplimiento de los requisitos del programa y a la revisión del propietario/administrador.\n\n5. Todos los documentos cargados deben tener fecha dentro de los 120 días de su fecha de mudanza.\n\n6. Usted reconoce que esta es una comunidad de ingresos restringidos y que los ingresos de su hogar deben cumplir con los requisitos de elegibilidad del programa.",
          accept: "He leído y acepto los Términos y Condiciones.",
        },
        signature: {
          title: "Firma",
          instructions:
            "Escriba su nombre legal completo a continuación para firmar electrónicamente esta solicitud.",
          label: "Nombre legal completo",
          required: "La firma es requerida",
          date: "Fecha",
        },
        submitButton: "Enviar Solicitud",
        submitError:
          "No pudimos enviar su solicitud. Inténtelo de nuevo o comuníquese con el equipo de la propiedad.",
        success: {
          title: "Solicitud Enviada",
          message:
            "Su solicitud ha sido enviada. El equipo de la propiedad la revisará y se comunicará con usted pronto.",
          backToApplications: "Volver a Solicitudes",
          correctionTitle: "Corrección Enviada",
          correctionMessage:
            "La solicitud corregida se ha reenviado y el contrato se ha actualizado. Puede cerrar esta pestaña y volver al panel de administración.",
          close: "Cerrar esta pestaña",
        },
      },
    },
  },
};
